<template lang='pug'>
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items='list'
  item-value='id'
  item-text='complex_type_name'
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Выберите тип комплекса'
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/complexTypes', ['fetch']),
  computed: mapGetters('dictionary/complexTypes', ['list'])
}
</script>
